// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';

// js utilities
import _ from 'lodash';

// import components from material UI
// import muiThemeable from 'material-ui/styles/muiThemeable';
import FlatButton from '../c_SourceModFlatButton';
import { stripUnknownProps } from '../../../utils/reactProps';

const flatButtonCustomization = {
  primary: true,
  disableTouchRipple: true,
  disableFocusRipple: true,
  style: {
    border: '1px solid #333333',
    color: '#4a4a4a',
    width: '100%',
    height: '25px',
    lineHeight: 'initial',
    backgroundColor: 'transparent'
  },
  labelStyle: {
    display: 'block',
    letterSpacing: '3.5px',
    top: '-3%',
    fontSize: '9.5px'
  },
  hoverStyle: {
    border: '1px solid #2eb0e3',
    color: '#2eb0e3'
  },
};

const disabledStyles = {
  backgroundColor: 'rgb(241,241,241)',
  border: '1px solid rgb(241,241,241)'
};


// @muiThemeable()  // muiThemeable brings in theme from provider at root
export default class CustomFlatButton extends Component {
  static propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    style: PropTypes.object,
    labelStyle: PropTypes.object,
    disabled: PropTypes.bool
  }

  static defaultProps = {
    style: {},
    labelStyle: {}
  }

  render() {
    const {
      className,
      label,
      style,
      labelStyle,
      disabled,
      ...otherProps
    } = this.props;

    const {
      style: flatButtonCustomizationStyle,
      labelStyle: flatButtonCustomizationLabelStyle,
      ...flatButtonCustomizationOther
    } = flatButtonCustomization;

    return (
      <FlatButton className={`flat-button ${className} ${disabled ? 'disabled' : ''}`}
                    data-id={`${label}${disabled ? ' Disabled' : ''}`}
                    label={label}
                    style={_.merge({}, flatButtonCustomizationStyle, disabled ? disabledStyles : {}, style)}
                    labelStyle={_.merge({}, flatButtonCustomizationLabelStyle, labelStyle)}
                    disabled={disabled}
                    {...stripUnknownProps(flatButtonCustomizationOther)}
                    {...otherProps}/>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/c_FlatButton/index.js